import { motion } from "framer-motion";

import { IoCloseOutline } from "react-icons/io5";

import { animatePage } from "../../animateConstant";
import CloseComponent from "../../components/CloseComponent/CloseComponent";
import SelectMethod from "./components/SelectMethod";
import { useTranslation } from "react-i18next";
import MethodToggle from "../Deposit/components/MethodToggle";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import LoadingBlock from "../../components/Loading/LoadingBlock";
import NotFound from "../../components/ProgressBlock/NotFound";
import BankWithdraw from "./components/bankWithdraw";
import WithdrawNotice from "./components/withdrawNotice";
import FromWithdrawHint from "./components/fromWithdrawHint";

const WithdrawStepOne = ({
  withdrawStep,
  withdrawMethod,
  setChooseCurrency,
  setWithdrawStep,
  setWithdrawData,
  isLoading,
  washConfig,
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`withdraw.${key}`);

  return (
    <motion.section
      initial={withdrawStep === 1 ? "hiddenRight" : "hiddenLeft"}
      animate="visible"
      exit={withdrawStep === 1 ? "hiddenRight" : "hiddenLeft"}
      variants={animatePage}
    >
      <CloseDetailPage title={i18n("withdraw")} />
      <section>
        {/* <p className="text-center text-transaction-text my-[20px]">
            {i18n("methodText")}
          </p> */}
        <section className="mb-[24px]">
          {/* <p className="font-semibold text-lg text-transaction-text mb-[10px]">
              {i18n("recommend")}
            </p>
            <LoadingBlock commonLoading={isLoading}>
              {withdrawMethod.length > 0 ? (
                withdrawMethod.map((item, index) => {
                  const method = item.payway3; //提款方式

                  return (
                    <SelectMethod
                      setChooseCurrency={setChooseCurrency}
                      setWithdrawStep={setWithdrawStep}
                      setWithdrawData={setWithdrawData}
                      currency={`PHP`}
                      method={method}
                      data={item}
                    />
                  );
                })
              ) : (
                <NotFound />
              )}
            </LoadingBlock> */}
          <BankWithdraw washConfig={washConfig} />
        </section>
      </section>
    </motion.section>
  );
};

export default WithdrawStepOne;
